import apiClient from '../apiClient';

export const getDashboardStats = () => apiClient.get('/client-admin/dashboard/stats');
